import type { BadgeProps } from "@mantine/core";
import { Badge } from "@mantine/core";
import type { PropsWithChildren } from "react";
import { forwardRef } from "react";
import classes from "../chat-components.module.css";

export const ChatPreviewBadge = forwardRef<
    HTMLDivElement,
    PropsWithChildren<BadgeProps & React.HTMLAttributes<HTMLDivElement>>
>(({ children, ...rest }, ref) => (
    <Badge ref={ref} className={classes.chat_preview_badge} {...rest}>
        {children}
    </Badge>
));

ChatPreviewBadge.displayName = "ChatPreviewBadge";
